var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFillcheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.196411,
    y: 0.785706,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "url(#paint0_linear_1463_669)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7244 10.4307C20.7975 10.4803 20.8588 10.5425 20.9051 10.6134C20.9513 10.6844 20.9814 10.7629 20.9938 10.8443C21.0061 10.9257 21.0004 11.0085 20.977 11.088C20.9536 11.1674 20.913 11.242 20.8574 11.3073L13.4192 20.0576C13.3588 20.1285 13.2823 20.187 13.1946 20.2292C13.107 20.2713 13.0103 20.2962 12.9111 20.3021C12.8118 20.3081 12.7123 20.2949 12.6192 20.2635C12.5261 20.2321 12.4416 20.1832 12.3713 20.1201L8.18728 16.37C8.0641 16.2515 7.99704 16.0948 8.00023 15.9329C8.00342 15.771 8.0766 15.6165 8.20437 15.502C8.33213 15.3874 8.5045 15.3219 8.68516 15.319C8.86581 15.3161 9.04066 15.3762 9.17285 15.4866L12.7934 18.7309L19.7482 10.5498C19.8601 10.4181 20.0258 10.3316 20.2088 10.3092C20.3918 10.2869 20.5773 10.3306 20.7244 10.4307Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1463_669",
    x1: 0.196411,
    y1: 15.2857,
    x2: 29.1964,
    y2: 15.2857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AB1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillcheck);
export default __webpack_public_path__ + "static/media/fill check.18ee1bc63e7e43eadf59893ae895c32c.svg";
export { ForwardRef as ReactComponent };